import React, { Component } from 'react';
import _ from 'lodash';
import { Document, Page } from 'react-pdf';
import {isMobile, isTablet, isDesktop, withOrientationChange} from 'react-device-detect';

import './DocumentExample.css';

import TestPdf from '../../../assets/images/test.pdf';
import WorkflowProcessStore from '../../../stores/WorkflowProcessStore';

class DocumentExample extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      numPages: null,
      pageNumber: 1,
    }
  }

  componentDidMount(){

  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  }

  render(){
    const { pageNumber, numPages } = this.state;
    const { isLandscape, isPortrait } = this.props;

    let pdfWidth = 265;
    if (isTablet && isLandscape){
      pdfWidth = 808;
    } else if(isTablet && isPortrait) {
      pdfWidth = 594;
    } else if(isMobile && isLandscape) {
      pdfWidth = 500;
    } else {
      pdfWidth = 265;
    }

    return (
      <div className='mt-2 pb-4'>
        {!_.isEmpty(this.props.pdf_file) && (
          <div>

            {isDesktop ? (
              <div className="row">
                <div className='col-12 text-center'>
                  <iframe style={{margin: '0 auto', width: '950px', height: '842px'}} src={this.props.pdf_file.attributes.url}></iframe>
                </div>
              </div>
            ) : (
              <div className='py-4 mt-2 bg-secondary col-10 ml-auto mr-auto'>
                <Document
                  file={this.props.pdf_file.attributes.url}
                  onLoadSuccess={this.onDocumentLoad}>
                  {
                    Array.from(
                      new Array(numPages),
                      (el, index) => (
                        <Page
                          key={`page_${index + 1}`}
                          className={'mb-3'}
                          width={pdfWidth}
                          pageNumber={index + 1}
                        />
                      )
                    )
                  }
                </Document>
                <p className='text-center my-2'>Page {pageNumber} of {numPages}</p>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

export default withOrientationChange(DocumentExample);



// WEBPACK FOOTER //
// ./src/components/documents/actions/DocumentExample.js